"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EAuthenticateStatus = exports.EAuthenticateError = void 0;
let EAuthenticateStatus = exports.EAuthenticateStatus = /*#__PURE__*/function (EAuthenticateStatus) {
  EAuthenticateStatus["Initial"] = "initial";
  EAuthenticateStatus["Loading"] = "loading";
  EAuthenticateStatus["Succeed"] = "succeed";
  EAuthenticateStatus["Failed"] = "failed";
  return EAuthenticateStatus;
}({});
let EAuthenticateError = exports.EAuthenticateError = /*#__PURE__*/function (EAuthenticateError) {
  EAuthenticateError["Common"] = "common";
  EAuthenticateError["EmailRequired"] = "emailRequired";
  EAuthenticateError["EmailTaken"] = "emailTaken";
  EAuthenticateError["Unexpected"] = "unexpected";
  return EAuthenticateError;
}({});